
import { defineComponent } from 'vue';
import { findClassColor } from '@/scss/StyleClassManager';
import timer from '@/Utilities/timer';
import PrzElementContent from '../ContentElement/Component.vue';
import { BlockItemContent } from '@/models/Blocks/Itens/Types/block-content-types';

export default defineComponent({
    components:{
        PrzElementContent
    },
    props:{
        timer:{
            type: Number,
            default: 0
        },
        color:{
            type: String,
            default: '#FFFFFF'
        },
        title:{
            type: Object as () => BlockItemContent,
            default: () => {return {}}
        },
        className:{
            type: [Object, String],
            default: () => {}
        }
    },
    data(){
        return {
            timerClass: {},
            timerStyle: '',
            timerShow: false,
            hours: 0,
            mins: 0,
            secs: 0
        }
    },
    mounted(){
        let timerClass = this.color ? findClassColor(this.color) : null;
        if(timerClass){
            this.timerClass = timerClass;
        }else{
            this.timerStyle = this.color ? 'color: ' + this.color : '';
        }
        this.setVar();
    },
    computed:{
        hoursFormat(){
            return timer.formatNumberCounter(this.hours);
        },
        minsFormat(){
            return timer.formatNumberCounter(this.mins);
        },
        secsFormat(){
            return timer.formatNumberCounter(this.secs);
        },
    },
    methods:{
        setVar() {
            let calc = timer.calcTimerCounter(this.timer);
            if(!calc){
                this.timerShow = false;
                return;
            }
            this.secs = calc.secs;
            this.mins = calc.mins;
            this.hours = calc.hours;
            setTimeout(() => {this.setVar();}, 1000);
            this.timerShow = true;
        }
    }
});
